import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import * as requiredUrls from '../../../../utils/appointment.url'
import {
  Loading
} from 'element-ui'
export default {
  components: {
    BreadCrumb,
    steps
  },
  data () {
    return {
      activeName: '0',
      // _areaCode: '', //地区编码
      is_deploy: 0, // 是否部署新申办   1-部署，0-未部署
      hallList: [], //大厅数据
      hallAreaType: "", //现场个性化标识，阳江YJ 韶关SG 空值则代表默认
      loading: null,
    }
  },
  methods: {
    toNext (item) {
      this.$router.push({
        path: '/chooseUnit',
        query: {
          hallSeq: item.seq
        }
      })
    },
    // 获取大厅列表(区镇)
    getHallList1 (areaCode) {
      requiredUrls.hallInfoList({
        areaCode: areaCode || sessionStorage.getItem('areaCode'),
        includeChild: 0,
        pageRowNum: 999,
        hallType: 1 // 1普通大厅，2专业大厅
      }, 'get').then(res => {
        if (+res.status === 200) {
          this.hallAreaType != 'SG' ? this.getHallList2(areaCode) : this.loading.close();
          this.hallList.push({
            label: this.hallAreaType == 'YJ' ? '市级政务服务中心' : this.hallAreaType == 'SG' ? '市政务服务中心' : '区政务服务中心', 
            list: res.data.dataList
          })
        } else {
          this.loading.close()
          this.$message.error(res.desc)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
      })
    },
    // 获取大厅列表(专业大厅)
    getHallList2 (areaCode) {
      requiredUrls.hallInfoList({
        areaCode: areaCode || sessionStorage.getItem('areaCode'),
        includeChild: this.hallAreaType == 'YJ' ? 2 : 1,
        pageRowNum: 999,
        hallType: this.hallAreaType == 'YJ' ? 1 : 2, // 1普通大厅，2专业大厅
        areaLevel: this.hallAreaType == 'YJ' ? 3 : ""
      }, 'get').then(res => {
        if (+res.status === 200) {
          this.hallAreaType != 'SG' ? this.getHallList3(areaCode) : ""
          this.hallList.push({
            label: this.hallAreaType == 'YJ' ? '区县政务服务中心' : '专业大厅', 
            list: res.data.dataList
          })
        } else {
          this.loading.close()
          this.$message.error(res.desc)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
      })
    },
    // 获取大厅列表(镇街)
    getHallList3 (areaCode) {
      requiredUrls.hallInfoList({
        areaCode: areaCode || sessionStorage.getItem('areaCode'),
        includeChild: 2,
        pageRowNum: 999,
        hallType: 1, // 1普通大厅，2专业大厅
        areaLevel: this.hallAreaType == 'YJ' ? 4 : ""
      }, 'get').then(res => {
        if (+res.status === 200) {
          this.hallList.push({
            label: '镇街政务服务中心', 
            list: res.data.dataList
          })
        } else {
          this.$message.error(res.desc)
        }
        this.loading.close()
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
      })
    },
    goToServeInfo () {
      window.open(`${process.env.BASE_URL}appointment.html#/reserveInfo`, '_blank')
    },
    /*
      阳江预约界面文字及数据展示需求：禅道6311
      韶关只展示一个：禅道6304
    */
    // 获取外网参数
    getOutnetConfig () {
      // 是否部署新申办   1-部署，0-未部署
      requiredUrls.interOutnetConfig({
        key: 'APPOINTMENT_HALL_TYPE;RESERVE_DEPLOY;RESERVE_AREA_CODE'
      },
      'get'
      ).then(res => {
        if (res.status == 200) {
          let areaCode = "";
          res.data.map((item, index) => {
            if (item.key == 'RESERVE_DEPLOY') {
              this.is_deploy = item.value
              sessionStorage.setItem('RESERVE_DEPLOY', item.value)
            } else if(item.key == 'APPOINTMENT_HALL_TYPE'){
              this.hallAreaType = item.value;//地区标识：阳江YJ 韶关SG
            } else {
              areaCode = item.value
              sessionStorage.setItem('areaCode', item.value)
            }
          })
          this.getHallList1(areaCode)
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    handleClick(tab) {
      sessionStorage.setItem("hallType",tab.index)
    }
  },
  mounted () {
    this.loading = Loading.service({
      fullscreen: true
    })
    this.getOutnetConfig()
  }
}
